import React, {Component} from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import {connect} from "react-redux";
import {Button, IconButton} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Clear';
import {withStyles} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import api from "../../config/AxiosConfig";
import RentTab from "./RentTab";
import LogTab from "./LogTab";
import DocumentsTab from "./DocumentsTab";
import DamageTab from "./DamageTab";
import {RENT_SET, CAR_DAMAGE} from "../../store/helpers/constantVariables";

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "column",
        paddingBottom: theme.spacing(1)
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width: 200
    },
    dialogPaper: {
        height: "80vh"
    },
    pointer: {
        cursor: "pointer"
    },
    dialogHeader: {
        display: "flex",
    },
    spacer: {
        flex: 1,
    }
});


class ReservationDialog extends Component {
    state = {
        isError: false,
        isEdit: false,
        value: 0,
        rent: { ...RENT_SET },
        changes: [],
        damage: { ...CAR_DAMAGE },
        selectedClient: "",
        car: null,
        cars: [],
    };

    onRentChangeHandler = (event, value) => {
        const rent = {...this.state.rent};
        if (typeof event === "string") {
            if (event === "czas_od" ||
                event === "czas_do" ||
                event === "kierowca1_prawo_data" ||
                event === "kierowca2_prawo_data"
            ) {
                rent[event] = moment(value).unix();
            }
        } else {
            if (event.target.name == 'nr_zlecenia_serwisowego') {
                rent['numer_zlecenia_serwisowego'] = event.target.value;
                rent['nr_zlecenia_serwisowego'] = event.target.value;
            } else if (event.target.name == 'kierowca1_nazwa') {
                rent['kierowca1_imie'] = event.target.value;
                rent['kierowca1_nazwa'] = event.target.value;
            } else if (event.target.name == 'kierowca2_nazwa') {
                rent['kierowca2_imie'] = event.target.value;
                rent['kierowca2_nazwa'] = event.target.value;
            } else {
                rent[event.target.name] = event.target.value;
            }
        }
        this.setState({rent});
    };

    onSelectedClientChangeHandler = name => {
        const selectedClient = name;
        if (selectedClient) {
            const rent = {...this.state.rent};
            const client = this.props.clients.find(
                client => client.nazwa === selectedClient
            );
            rent.klient_rodzaj = client.rodzaj;
            rent.ulica = client.ulica;
            rent.dowod = client.dowod;
            rent.email = client.email;
            rent.pesel = client.pesel;
            rent.kod = client.kod;
            rent.limitkm = client.limitkm;
            rent.ulica = client.ulica;
            rent.miasto = client.miasto;
            rent.nazwa = client.nazwa;
            rent.nip = client.nip;
            rent.regon = client.regon;
            rent.telefon = client.telefon
            rent.kierowca1_prawo_data = client.data_prawa_jazdy
            rent.kierowca1_nazwa = client.kierowca_imie;
            rent.kierowca1_kod = client.kierowca_kod;
            rent.kierowca1_miasto = client.kierowca_miasto;
            rent.kierowca1_pesel = client.kierowca_pesel;
            rent.kierowca1_telefon = client.kierowca_telefon;
            rent.kierowca1_ulica = client.kierowca_ulica;
            rent.kierowca1_organ = client.organ;
            rent.kierowca1_prawo = client.prawo_jazdy;
            this.setState({rent});
        }
        this.setState({selectedClient});
    };

    onDamageChangeHandler = areaName => {
        const damage = {...this.state.damage};
        damage[areaName] = !damage[areaName];
        this.setState({damage});
    };

    onDamageDescriptionChangeHandler = event => {
        const damage = {...this.state.damage};
        damage[event.target.name] = event.target.value;
        this.setState({damage});
    };

    onNewRentHandler = (payload, closeDialog, callBack) => {
        let url = this.state.isEdit
            ? `kalendarz/edycja_wynajem.php?id_wynajem=${payload.id_wynajem}`
            : "kalendarz/dodaj_wynajem.php";
        if (this.state.isEdit) {
            api
                .put(url, payload)
                .then(response => {

                    console.log("response", response);

                    this.props.addCar(payload.id_wynajem);
                    if (closeDialog) {
                        this.props.closeDialog();
                    }

                    if (callBack) {
                        callBack();
                    }
                })
                .catch(error => {
                    console.log("error", error);
                    this.setState({isError: true})
                });
        } else {
            api
                .post(url, payload)
                .then(response => {
                    console.log("response", response);
                    this.props.fetchCars();
                    this.changeAddToEditRentDialog(response.data.wynajem[0]);
                })
                .catch(error => {
                    console.log("error", error);
                    this.setState({isError: true})
                });
        }
        this.updateDamageHandler();
    };

    onDownloadDocumentsHandler = doc => {
        const url = `http://${doc.link}`;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
    };

    updateDamageHandler = () => {
        const url = `kalendarz/edycja_uszkodzenia.php?id_wynajem=${this.state.rent.id_wynajem}`;
        const data = {
            ...this.state.damage,
            opcja: this.state.isEdit ? 2 : 1,
            token: this.props.token
        };

        api.put(url, data).then(response => {
        });
    };

    changePoolDescriptionHandler = (event) => {
        this.setState({opis: event.target.value})
    };

    handleTabChange = (event, value) => {
        this.setState({value});
    };

    constructor(props) {
        super(props);

        this.state.isEdit = this.props.isEdit;
        this.state.rent = {...props.rent};
    }

    editPoolHandler = () => {
        let url = "/kalendarz/edytuj_pool.php";
        const data = {
            token: this.props.token,
            id_wynajem: this.state.rent.id_wynajem,
            opis: this.state.opis
        };
        api
            .put(url, data)
            .then(response => console.log(response))
            .catch(e => console.log(e));
    };

    changeAddToEditRentDialog = (newAddedRent) => {
        this.setState({isEdit: true});
        this.setState({rent: newAddedRent});
        this.initializeDialog();
    };

    componentDidMount() {
        let tmp;
        if (this.props.carId) {
            tmp = this.props.cars && this.props.cars.find(cr => cr.id === this.props.carId);
        } else {
            tmp = this.props.cars
                && this.state.rent
                && this.props.cars.find(cr => cr.id === this.state.rent.id_samochod);
        }
        this.setState({car: tmp});

        this.initializeDialog();
    }

    initializeDialog() {
        let url;
        let data = {
            token: this.props.token,
            id_samochod: this.state.rent.id_samochod,
            id_wynajem: this.state.rent.id_wynajem
        };

        if (this.state.isEdit) {
            url = "/kalendarz/pokaz_zmiany.php";
            api.post(url, data).then(response => {
                if (response.data.zmiana) {
                    const changes = response.data.zmiana.sort((a, b) => {
                        return b.czas - a.czas;
                    });
                    this.setState({changes});
                }
            });

            if (this.state.rent.rodzaj === "Pool") {
                url = "/kalendarz/pokaz_pool.php";
                api.post(url, data).then(response => {
                    this.setState({
                        opis: response.data.pool[0].opis
                    });
                });
            } else {
                url = "/kalendarz/pokaz_uszkodzenia.php";
                api.post(url, data).then(response => {
                    const damage = response.data.uszkodzenia_po
                        ? response.data.uszkodzenia_po[0]
                        : response.data.uszkodzenia_przed[0];

                    this.setState({damage});
                });

                url = "kalendarz/dokumenty.php";

                api.post(url, data).then(response => {
                    const documents = [...response.data.umowa];
                    this.setState({documents: documents});
                });
            }
        }
    }

    render() {
        let {classes} = this.props;
        const {value, car, isEdit} = this.state;

        return (
            <Dialog
                open={this.props.isDialogOpen}
                fullScreen={this.state.rent.rodzaj !== "Pool" ? true : false}
            >
                {this.state.rent.rodzaj !== "Pool" ? (
                    <>
                        <DialogContent>
                            <div className={classes.dialogHeader}>
                                <h3>
                                    Najem
                                    samochodu: {car && <>{car.rejestracja} - {car.marka} {car.model} {car.opis}</>}
                                </h3>
                                <span className={classes.spacer}></span>
                                <IconButton onClick={this.props.closeDialog}>
                                    <CloseIcon/>
                                </IconButton>
                            </div>
                            <AppBar position="relative">
                                <Tabs
                                    variant="scrollable"
                                    value={value}
                                    onChange={this.handleTabChange}
                                >
                                    <Tab label="Zarządzanie Wynajmem"/>
                                    {isEdit && <Tab label="Zarządzanie uszkodzeniami"/>}
                                    {isEdit && <Tab label="Wydruk dokumentów"/>}
                                    {isEdit && <Tab label="Rejestr zmian najmu"/>}
                                </Tabs>
                            </AppBar>
                            {value === 0 && (
                                <RentTab
                                    rent={this.state.rent}
                                    onRentChange={this.onRentChangeHandler.bind(this)}
                                    isError={this.state.isError}
                                    clients={this.props.clients}
                                    isEdit={isEdit}
                                    selectedClient={this.state.selectedClient}
                                    onSelectedClientChangeHandler={this.onSelectedClientChangeHandler.bind(this)}
                                />
                            )}
                            {value === 1 && (
                                <DamageTab
                                    onDamageDescriptionChangeHandler={this.onDamageDescriptionChangeHandler.bind(this)}
                                    onDamageChangeHandler={this.onDamageChangeHandler.bind(this)}
                                    damage={this.state.damage}
                                />
                            )}
                            {value === 2 && (
                                <DocumentsTab
                                    update={(rent, callBack) => {
                                        this.onNewRentHandler(
                                            {
                                                ...rent,
                                                id_samochod: this.state.rent.id_samochod,
                                                token: this.props.token
                                            },
                                            false,
                                            () => callBack()
                                        );
                                    }}
                                    updateState={(values) => {
                                        const rent = {...this.state.rent, ...values};
                                        this.setState({rent})
                                    }}
                                    rent={this.state.rent}
                                    documents={this.state.documents}
                                    onDownloadDocumentsHandler={this.onDownloadDocumentsHandler.bind(this)}
                                />
                            )}
                            {value === 3 && <LogTab changes={this.state.changes}/>}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.props.closeDialog}>Anuluj</Button>
                            {isEdit
                                ?
                                <>
                                    <Button
                                        color="primary"
                                        disabled={this.state.rent.nazwa ? false : true}
                                        onClick={() => {
                                            this.onNewRentHandler(
                                                {
                                                    ...this.state.rent,
                                                    id_samochod: this.state.rent.id_samochod,
                                                    token: this.props.token
                                                },
                                                false
                                            );
                                        }}
                                    >
                                        Zapisz
                                    </Button>
                                    <Button
                                        disabled={this.state.rent.nazwa ? false : true}
                                        color="secondary"
                                        onClick={() => {
                                            this.onNewRentHandler(
                                                {
                                                    ...this.state.rent,
                                                    id_samochod: this.state.rent.id_samochod,
                                                    token: this.props.token
                                                },
                                                true
                                            );
                                        }}
                                    >
                                        Zapisz i zamknij
                                    </Button>
                                </>
                                :
                                <>
                                    <Button
                                        disabled={this.state.rent.nazwa ? false : true}
                                        color="secondary"
                                        style={{paddingRight: "16px", marginRight: "16px"}}
                                        onClick={() => {
                                            this.onNewRentHandler(
                                                {
                                                    ...this.state.rent,
                                                    id_samochod: this.props.carId,
                                                    token: this.props.token
                                                },
                                                true
                                            );
                                        }}
                                    >
                                        Dodaj
                                    </Button>
                                </>}

                        </DialogActions>
                    </>
                ) : (
                    <>
                        <DialogContent>
                            <TextField
                                value={this.state.opis}
                                onChange={this.changePoolDescriptionHandler}
                                type="text"
                                label="Cel podróży"
                                InputLabelProps={{
                                    shrink: this.state.opis ? true : false
                                }}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.props.closeDialog}>Anuluj</Button>
                            <Button
                                color="secondary"
                                onClick={() => {
                                    this.editPoolHandler();
                                    this.props.closeDialog()
                                }}
                            >
                                Zapisz i zamknij
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
        );
    }
}

const mapStateToProps = state => {
    return {
        token: state.authReducer.token,
        clients: state.formReducer.clients,
        cars: state.formReducer.cars,
    };
};

export default connect(mapStateToProps)(withStyles(styles)(ReservationDialog));
